export default "__VITE_ASSET__GDltxVIR__"